import { render, staticRenderFns } from "./setNewPwd.vue?vue&type=template&id=47f7531e&scoped=true&"
import script from "./setNewPwd.vue?vue&type=script&lang=js&"
export * from "./setNewPwd.vue?vue&type=script&lang=js&"
import style0 from "./setNewPwd.vue?vue&type=style&index=0&id=47f7531e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f7531e",
  null
  
)

export default component.exports